import React from "react";

const SunbitInviteSnippet = () => {
  return (
    <p>
      <b>Sunbit Invite:</b>
      {`{{SUNBITINVITE}}`}{" "}
    </p>
  );
};

export default SunbitInviteSnippet;
